import { createAsyncThunk } from "@reduxjs/toolkit";
import config from "../../config";
import axiosClient from "../../common/api/request";
import { guestRequestConfig } from "../patient/guestToken";

export const makeOrder = createAsyncThunk(
  "makeOrder",
  async (params, { rejectWithValue, getState }) => {
    try {
      const data = await axiosClient.post(
        `${config.API_URL}/orders/`,
        params,
        guestRequestConfig(getState())
      );
      return data;
    }  catch (error) {
      if (
        error.response &&
        error.response.data &&
        typeof error.response.data === "object"
      ) {
        return rejectWithValue(error.response.data);
      } else {
        return rejectWithValue(error?.message);
      }
    }
  }
);

export const makeOrderForUnAuthUser = createAsyncThunk(
  "makeOrder_for_un_authUser",
  async (params, { rejectWithValue, getState }) => {
    try {
      // The guest's order is placed for its own guest record only, proven by
      // the token that came with it (see guestToken.js).
      const data = await axiosClient.post(
        `${config.API_URL_V2}/orders/`,
        params,
        guestRequestConfig(getState())
      );
      return data;
    }  catch (error) {
      // The status rides in meta so checkout can tell "this guest record is
      // no longer yours" (404) from an order the backend refused.
      const meta = { status: error?.response?.status };
      if (
        error.response &&
        error.response.data &&
        typeof error.response.data === "object"
      ) {
        return rejectWithValue(error.response.data, meta);
      } else {
        return rejectWithValue(error?.message, meta);
      }
    }
  }
);

export const calculateOrder = createAsyncThunk(
  "calculateOrder",
  async (params, { rejectWithValue }) => {
    try {
      const data = await axiosClient.post(
        `${config.API_URL_V2}/orders/calculate/`,
        params,
        config
      );
      return data;
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        typeof error.response.data === "object"
      ) {
        return rejectWithValue(error.response.data);
      } else {
        return rejectWithValue({
          Error: error.message,
        });
      }
    }
  }
);